import Marquee from "react-fast-marquee";
import { Hexagon } from "lucide-react";

const items = [
  "Flatbed", "Container", "Low Bed", "Bogie", "A-Frame",
  "Oversized Equipment", "Cross-Border", "General Cargo", "Machinery Transport",
];

export const EditorialMarquee = () => (
  <div className="border-y border-royal/10 bg-white py-6" data-testid="editorial-marquee">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {items.map((item) => (
        <span key={item} className="mx-8 flex items-center gap-8">
          <span className="font-jakarta text-2xl font-extrabold uppercase tracking-[0.15em] text-navy/90 md:text-3xl">{item}</span>
          <Hexagon className="h-4 w-4 fill-gold text-gold" />
        </span>
      ))}
    </Marquee>
  </div>
);
